(function () {
    'use strict';

    angular
        .module('app')
        .controller('ViewEmailConversationDialogCtrl', ViewEmailConversationDialogCtrl);

    ViewEmailConversationDialogCtrl.$inject = ['DialogInstance', 'email'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing the 'Conversation items' of an email
     */
    function ViewEmailConversationDialogCtrl(DialogInstance, email) {
        /* jshint validthis:true */
        var vm = this;
        vm.cancel = cancel;
        vm.conversationEmails = [];
        vm.setSelectedEmail = setSelectedEmail;
        vm.emailFromAddressDisplay = emailFromAddressDisplay;
        vm.getStatusIcon = getStatusIcon;
        vm.getAttachmentIcon = getAttachmentIcon;
        vm.viewEmail = viewEmail;
        vm.replyEmail = replyEmail;
        vm.replyAllEmail = replyAllEmail;
        vm.forwardEmail = forwardEmail;
        Object.defineProperty(vm, 'selectedEmail', { get: getSelectedEmail });

        activate();

        function activate() {
            vm.loading = true;
            email.getConversation()
                .then(getConversationOk, getConversationError);

            function getConversationOk(data) {
                if (_.isNil(data) || data.length === 0) {
                    vm.conversationEmails = [email];
                } else {
                    vm.conversationEmails = data;
                }

                angular.forEach(vm.conversationEmails, function (n) {
                    if (n.data.Id === email.data.Id) {
                        n.selected = true;
                    }
                });

                vm.loading = false;
            }

            function getConversationError(response) {
                vm.error = 'The conversation list was unable to be retrieved.';
                vm.loading = false;
            }
        }

        /**
         * @returns {Email} Returns the currently selected email object.
         */
        function getSelectedEmail() {
            return _.find(vm.conversationEmails, function (n) {
                return n.selected;
            });
        }

        /**
         * @param {Email} Email to be selected.
         * 
         * Sets the supplied email to be selected and deselects all other emails in the list.
         */
        function setSelectedEmail(email) {
            angular.forEach(vm.conversationEmails, function (n) {
                n.selected = false;
            });

            email.selected = true;
        }

        /**
         * @returns {String} The From email address is returned in a user viewable format.
         */
        function emailFromAddressDisplay(email) {
            var result = '';

            if (!_.isNil(email.data.From) && email.data.From.length > 0) {
                if (!_.isNil(email.data.From[0].Name)) {
                    result = email.data.From[0].Name;
                } else {
                    result = email.data.From[0].Value;
                }
            }

            return result;
        }

        /**
         * @param {Email} Email to be checked to see if attachment icon is to be displayed
         *
         * If the supplied email has attachments, an 'attachment icon' will be returned.
         * Otherwise a blank string will be returned.
         *
         * @returns {String} Attachment icon to be shown.
         */
        function getAttachmentIcon(email) {
            var result = '';

            if (email.Attachments.length > 0) {
                result = 'attachment';
            }

            return result;
        }

        /**
         * @param {Email} Email to be checked to see which status icon should be used
         *
         * The status of the supplied email is checked to determine what icon should be returned.
         *
         * @returns {String} Status icon to be shown.
         */
        function getStatusIcon(email) {
            var result = '';

            if (email.data.Status === 'Draft') {
                result = 'draft';
            } else if (email.data.Status === 'Received') {
                result = 'received';
            } else if (email.data.Status === 'Sent') {
                result = 'sent';
            }

            return result;
        }

        /*
         * Closes dialog and returns an object containing an action of 'View' and the currently selected email.
         */
        function viewEmail() {
            DialogInstance.ok({ Action: 'View', Email: vm.selectedEmail });
        }

        /*
         * Closes dialog and returns an object containing an action of 'Reply' and the currently selected email.
         */
        function replyEmail() {
            DialogInstance.ok({ Action: 'Reply', Email: vm.selectedEmail });
        }

        /*
         * Closes dialog and returns an object containing an action of 'ReplyAll' and the currently selected email.
         */
        function replyAllEmail() {
            DialogInstance.ok({ Action: 'ReplyAll', Email: vm.selectedEmail });
        }

        /*
         * Closes dialog and returns an object containing an action of 'Forward' and the currently selected email.
         */
        function forwardEmail() {
            DialogInstance.ok({ Action: 'Forward', Email: vm.selectedEmail });
        }

        /*
         * Closes dialog with a cancelled state.
         */
        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
